var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.viewHasProgressIndicator)?_c('div',{staticClass:"main-view-progress-circle"},[_c('ProgressCircle',{attrs:{"progress":_vm.viewProgress}}),_vm._v(" "),_c('div',{staticClass:"control",domProps:{"innerHTML":_vm._s(_vm.progressLabel)}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }